import AbstractAlGuestlistEditorPagesController from '../../abstracts/abstract-page-controller';
import moment from 'moment';

export default class AlGuestlistEditorPageGeneralComponentController extends AbstractAlGuestlistEditorPagesController {

    constructor($injector, $scope) {
        super($injector, $scope);
        this.isPrivateGuestlist = false;
        this.dateFields = {
            start_date: null,
            end_date: null
        };
        this.currentUsers = [];
        this.currentUserUpdateIndex = 1;
        this.modelInitiated = false;
    }

    updateUserPermission(update, $index, permissions) {
        const newState = _.cloneDeep(this.state);

        if (update) {
            _.forEach(permissions, function (perm) {
                _.set(newState, `model.users.${$index}.permissions.${perm}`, true);
            });
        }

        this._updateState(newState);
    }

    /**
     * Opens popup to add new users to the guestlist permissions list
     */
    addUsers() {
        this.injector.get('SelectBox').single(this.injector.get('Users').reset({
            persists: false,
            listname: 'GuestlistPermissionUserSelectList'
        }), {
            displayField: 'master_user.full_name'
        }).then((selectedUserData) => {
            const present = _.filter(this.currentUsers, function (o) {
                return o.user.id === selectedUserData.data;
            });

            if (present.length === 0) {
                this.injector.get('User').get(selectedUserData.data).then((fullUser) => {
                    this.currentUsers.push({
                        user: fullUser,
                        permissions: {read: 1, write: 0, delete: 0, admin: 0}
                    });
                });
            } else {
                this.injector.get('Alert').warning(this.translate.instant(`guestlists.editor.pages.general.alerts.user_already_exists_in_permissions_list`));
            }
        });
    }

    /**
     * Removes the specified user from the selected permissions
     *
     * @param userToDelete
     */
    removeUser(userToDelete) {
        const indexToDelete = this.currentUsers.indexOf(userToDelete);

        if (indexToDelete !== -1) {
            this.currentUsers.splice(indexToDelete, 1);
        }
    }

    _initWatchers() {
        super._initWatchers();
        this.scope.$watch(() => {
            return this.isPrivateGuestlist;
        }, () => {
            this.model.permission = this.isPrivateGuestlist ? 'private' : 'public';
        });

        this.scope.$watch(() => {
            return this.dateFields.start_date;
        }, () => {
            if (this.modelInitiated) {
                if (this._validateDateFields()) {
                    _.set(this.model, 'settings.start_date', this.dateFields.start_date ? this.transformDateFieldForModel(this.dateFields.start_date) : null);
                } else {
                    this.dateFields.end_date = _.cloneDeep(this.dateFields.start_date);
                    this.injector.get('$timeout')(() => {
                        _.set(this.model, 'settings.start_date', this.dateFields.start_date ? this.transformDateFieldForModel(this.dateFields.start_date) : null);
                    }, 0);
                }
            }
        }, true);

        this.scope.$watch(() => {
            return this.dateFields.end_date;
        }, (newVal, oldVal) => {
            if (this.modelInitiated) {
                if (this._validateDateFields(true)) {
                    _.set(this.model, 'settings.end_date', this.dateFields.end_date ? this.transformDateFieldForModel(this.dateFields.end_date) : null);
                } else {
                    this.dateFields.end_date = oldVal;
                }
            }
        }, true);

        this.scope.$watch(() => {
            return this.currentUsers;
        }, () => {
            if(this.modelInitiated) {
                if (this.currentUsers.length > 0) {
                    this.isPrivateGuestlist = true;
                }

                const currentUpdateIndex = _.cloneDeep(++this.currentUserUpdateIndex);

                this.model.users = null;
                this.injector.get('$timeout')(() => {
                    if (currentUpdateIndex >= this.currentUserUpdateIndex) {
                        this.model.users = _.map(this.currentUsers, (information) => {
                            return {
                                user: {
                                    id: information.user.id
                                },
                                permissions: information.permissions
                            }
                        });

                        if (this.model.users && this.model.users.length > 0) {
                            this.isPrivateGuestlist = true;
                        }
                        this._triggerModelUpdate();
                    }
                }, 0);
            }
        }, true);
    }

    _initFormConfig() {
        this._updateState({
            ...this.state,
            formConfig: {
                ...this.state.formConfig,
                categorySelectBox: {
                    store: this.injector.get('Categories').reset({persist: false}),
                    displayField: 'name',
                    valueField: 'id',
                    maxItems: 15
                }
            }
        });
    }

    /**
     * @private
     */
    _fillModelFromGuestlist() {
        this.model = _.cloneDeep({
            name: this.getGuestlistValue('name'),
            uid: this.getGuestlistValue('uid'),
            settings: {
                start_date: this.getGuestlistValue('settings.start_date'),
                end_date: this.getGuestlistValue('settings.end_date'),
                location_information: {
                    name: this.getGuestlistValue('settings.location_information.name'),
                    street: this.getGuestlistValue('settings.location_information.street'),
                    zip: this.getGuestlistValue('settings.location_information.zip'),
                    city: this.getGuestlistValue('settings.location_information.city'),
                    country: this.getGuestlistValue('settings.location_information.country')
                },
                add_contacts_to_addressbook: this.getGuestlistValue('settings.add_contacts_to_addressbook')
            },
            permission: this.getGuestlistValue('permission'),
            users: this.getGuestlistValue('users')
        });

        if (this.model.settings.start_date) {
            this.dateFields.start_date = this.transformDateForDateField(this.model.settings.start_date);
        }

        if (this.model.settings.end_date) {
            this.dateFields.end_date = this.transformDateForDateField(this.model.settings.end_date);
        }

        this.currentUsers = this.getGuestlistValue('users');

        this.isPrivateGuestlist = this.model.permission === 'private';

        this.injector.get('$timeout')(() => {
            this.modelInitiated = true;
        }, 0);
    }

    /**
     *
     * @private
     */
    _validateDateFields(showNotice) {
        if (
            this.modelInitiated
            && (
                _.isEmpty(this.dateFields.start_date)
                || _.isEmpty(this.dateFields.end_date)
                || (moment(this.dateFields.start_date, 'Y-M-D HH:mm') > moment(this.dateFields.end_date, 'Y-M-D HH:mm'))
            )
        ) {
            if (showNotice) {
                this.injector.get('SweetAlert').error(this.translate.instant(`guestlists.editor.pages.general.alerts.end_date_after_start_date.title`), this.translate.instant(`guestlists.editor.pages.general.alerts.end_date_after_start_date.message`));
            }
            return false;
        }

        return true;
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/guestlists/components/al-guestlist-editor/pages/general/controller.js